


float PI = 3.141592653589793;
 varying vec2 vUv;
 uniform float uProgress;

void main()
  {   
    vec3 newPosition= position;
    float smoothProgress=smoothstep(0., 1., uProgress);

    newPosition.z=-0.5*smoothProgress;
    gl_Position = projectionMatrix * viewMatrix * modelMatrix * vec4(newPosition, 1.0);
    vUv=uv;
}